import React from 'react'

interface IconProps {
  className?: string
}

const XMark = ({ className }: IconProps) => (
  <svg
    fill="none"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default XMark
